// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"233":"c2b408c2","250":"dd4b401e","709":"dd4b401e"}[chunkId] + ".chunk.css";
};